/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import userAvatar from "../assets/img/img1.jpg";
import { post } from "../helper/api_helper";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.png";
export function withNavigation(Component) { return function (props) { const navigate = useNavigate(); return <Component {...props} navigate={navigate} />; }; }
class Sidebar extends Component {
  state = {
    menuList: [],
    loadingMenu: true,
  };

  componentDidMount() {
    this.fetchPermissions();
  }

  fetchPermissions = async () => { 
    const authEmployee = localStorage.getItem("authEmployee");
    const role_id_fk = authEmployee ? JSON.parse(authEmployee).role_id : null;

    if (!role_id_fk) return;

    try {
      const response = await post("settings/menu_permission/getPermission", { role_id_fk });
      this.setState({ menuList: response.data || [] });
    } catch (error) {
      console.error("Error fetching permissions:", error);
    } finally {
      this.setState({ loadingMenu: false });
    }
  };

  handleLogout = () => {
    localStorage.removeItem("authEmployee");
    this.props.navigate("/login");
  };

  renderIcon = (icon) =>
    icon ? (
      <b className="menu-icon" dangerouslySetInnerHTML={{ __html: icon }} />
    ) : (
      <b className="menu-icon" />
    );
    hasAnyPermission = (menu) => {
      return (
        menu.list_permission === "1" ||
        menu.add_permission === "1" ||
        menu.edit_permission === "1" ||
        menu.view_permission === "1" ||
        menu.delete_permission === "1" ||
        menu.print_permission === "1"
      );
    };
  // Recursive renderer for menu
  renderMenu = (menus) => { 
    return (
    <div class="nav-group show">
      <ul className="nav nav-sidebar"> 
        {menus.filter((menu) => this.hasAnyPermission(menu) || (menu.child && menu.child.some((child) => this.hasAnyPermission(child)))).map((menu, key) => {
          const hasChildren = menu.child && Array.isArray(menu.child) && menu.child.length > 0;

          return (
            <li key={key} className="nav-item">
              {hasChildren ? (
                <>
                  <div
                    onClick={(e) => this.toggleSubMenu(e)}
                    className="nav-link has-sub"
                  >
                    {this.renderIcon(menu.menu_icon)}
                    <span>{menu.menu_name}</span>
                  </div>
                  <nav className="nav nav-sub">
                    {this.renderChildMenu(menu.child)}
                  </nav>
                </>
              ) : (
                <NavLink to={menu.menu_url || "/"} className="nav-link">
                  {this.renderIcon(menu.menu_icon)}
                  <span>{menu.menu_name}</span>
                </NavLink>
              )}
            </li>
          );
        })}
      </ul>
    </div>
    );
  };

renderChildMenu = (childmenus) => {
  return childmenus.filter((menu) => this.hasAnyPermission(menu)).map((childmenu, key) => (
    <NavLink
      key={key}
      to={childmenu.menu_url || "/"}
      className="nav-sub-link"
    >
      {childmenu.menu_name}
    </NavLink>
  ));
};


  // Toggle submenu while closing siblings
  toggleSubMenu = (e) => {
    e.preventDefault();

    let parent = e.target.closest(".nav-item");
    let node = parent.parentNode.firstChild;

    while (node) {
      if (node !== parent && node.nodeType === Node.ELEMENT_NODE) {
        node.classList.remove("show");
      }
      node = node.nextElementSibling || node.nextSibling;
    }

    parent.classList.toggle("show");
  };

  render() {
    const { menuList, loadingMenu } = this.state;
    const authEmployee = localStorage.getItem("authEmployee");
    const employee_name = authEmployee ? JSON.parse(authEmployee).employee_name : null;
    const role_name = authEmployee ? JSON.parse(authEmployee).role_name : null;
    return (
      <div className="sidebar">
        <div className="sidebar-header">
          <Link to="/" className="sidebar-logo">
            <img src={logo} width={"100%"} alt="logo"/>
          </Link>
        </div>

        <PerfectScrollbar
          className="sidebar-body"
          ref={(ref) => (this._scrollBarRef = ref)}
        >
          {!loadingMenu && this.renderMenu(menuList)}
        </PerfectScrollbar>

        <div className="sidebar-footer">
          <div className="sidebar-footer-top">
            <div className="sidebar-footer-thumb">
              <img src={userAvatar} alt="" />
            </div>
            <div className="sidebar-footer-body">
              <h6>
                <Link to="/">{employee_name}</Link>
              </h6>
              <p>{role_name}</p>
            </div>
            <Link
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector(".sidebar")
                  .classList.toggle("footer-menu-show");
              }}
              to=""
              className="dropdown-link"
            >
              <i className="ri-arrow-down-s-line"></i>
            </Link>
          </div>

          <div className="sidebar-footer-menu">
            
            <nav className="nav">
              <Link to="" onClick={this.handleLogout}>
                <i className="ri-logout-box-r-line"></i> Log Out
              </Link>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default withNavigation(Sidebar);
